import React from 'react';
import { Card } from '@frontend/shadcn/components/ui/card';
import { cn } from '@frontend/shadcn/lib/utils';

interface TaskCardProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  className?: string;
  onClick?: () => void;
}

export const TaskCard: React.FC<TaskCardProps> = ({
  icon,
  title,
  description,
  className,
  onClick,
}) => {
  return (
    <Card
      className={cn(
        'w-full p-4 bg-white rounded-2xl border border-gray-200 hover:border-gray-300 transition-colors cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2 min-w-0">
          {icon && (
            <div className="flex-shrink-0 flex justify-center items-center text-grey-4 w-5 h-5">
              {icon}
            </div>
          )}
          <h3 className="flex-1 text-grey-6 text-sm font-medium leading-normal truncate m-0">
            {title}
          </h3>
        </div>
        <p className="text-grey-5 text-xs font-normal leading-normal line-clamp-2 m-0">
          {description}
        </p>
      </div>
    </Card>
  );
};
